"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domReady = void 0;

var domReady = function domReady(callback) {
  if (['interactive', 'complete'].includes(document.readyState)) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

exports.domReady = domReady;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/listeners/domReady.js
// module id = 267
// module chunks = 5 6 7